export default "__VITE_ASSET__DdFkuQf6__"